import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_OFFERS_ERROR, UPDATE_OFFERS_START, UPDATE_OFFERS_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/offers_by_cycle/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_OFFERS_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-offers-by-cycle'))
    } catch (error) {
        yield put({type: UPDATE_OFFERS_ERROR, error});
    }      
}

export default function* update_offers() {
    yield takeLatest(UPDATE_OFFERS_START, update);
}